"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerEmailHandlebarsHelpers = void 0;
const registerEmailHandlebarsHelpers = (instance) => {
    instance.registerHelper("or", (...args) => {
        const values = args.slice(0, -1);
        return values.some((value) => Boolean(value));
    });
    instance.registerHelper("and", (...args) => {
        const values = args.slice(0, -1);
        return values.every((value) => Boolean(value));
    });
    instance.registerHelper("eq", (a, b) => a === b);
    instance.registerHelper("increment", (value) => Number(value) + 1);
};
exports.registerEmailHandlebarsHelpers = registerEmailHandlebarsHelpers;
